<template>
  <div class="whiteboard-container">
    <whiteboard
      ref="wb"
      :image-loader="fetchResourceContent"
      :settings="whiteboardSettings"
      :zoom.sync="zoom"
      :hide-zoom-control="true"
    />
  </div>
</template>

<script>
import WBP from 'smarttech-webwhiteboard'
import MockFirebaseReference from '@/utils/snapshot-wrapper'
import csSdkManager from '@/managers/cs-sdk-manager'

export default {
  name: 'WbpRenderer',
  components: {
    whiteboard: { ...WBP.VueComponents.Whiteboard }
  },
  props: {
    pageLpp: {
      type: Object,
      required: true
    },
    region: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      zoom: 1.0
    }
  },
  computed: {
    whiteboardSettings() {
      return {
        fitEntireWorkspace: true,
        useV2WebLinkIcon: true,
        useLinksPage: false,
        useLinksWeb: true,
        readAnnotationLPPLinkProperty: true,
        annotationLinkVariant: true,
        imagesAlwaysShowSpinnerOnLoad: false,
        wdktoolsave: false,
        editNotebookText: true,
        textEditingEnabled: true,
        useNewTextLayout: true
      }
    }
  },
  mounted() {
    this.renderFromLPPSnapshot()
  },
  methods: {
    fetchResourceContent({ contentId }) {
      return new Promise(resolve => {
        const csClient = csSdkManager.getCSClient({ region: this.region })
        csClient.getContentProfile([contentId]).then(res => {
          resolve(res[0] || {})
        })
      })
    },
    renderFromLPPSnapshot() {
      if (!this.pageLpp.page) {
        return
      }

      return new Promise(resolve => {
        this.$nextTick(() => {
          // Create a fake page to contain the lpp data
          const nodeWrapper = new MockFirebaseReference('collab-space', {
            pages: {
              [this.pageId]: this.pageLpp.page
            },
            resourceMap: this.pageLpp.resourceMap
          })
          this.setWhiteboardCollaborationNode(nodeWrapper, `pages/${this.pageId}`)
          resolve()
        })
      })
    },
    setWhiteboardCollaborationNode(nodeWrapper, pagePath) {
      this.$refs.wb.setCollaborationNode(nodeWrapper, pagePath)
    }
  }
}
</script>

<style scoped>
.whiteboard-container {
  width: 100%;
}
</style>
